import React from 'react';
import { TariffName } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { useDashboardContext } from '../../context/dashboard-context';
import { DynamicHours } from './tariffs/dynamic';
import { G11Hours } from './tariffs/g11';
import { TauronG13SHours } from './tariffs/g13s';
import { GnHours } from './tariffs/gn';

export const DashboardHoursByTariff: React.FC = () => {
  const { tariff } = useDashboardContext();

  if (!tariff) return null;

  if (tariff === TariffName.Dynamic) return <DynamicHours />;
  if (tariff === TariffName.G13S) return <TauronG13SHours />;
  if (tariff === TariffName.G11) return <G11Hours />;

  return <GnHours />;
};
